<template>
  <pi-content className="white">
    <div class="my-cash-custom">
      <!--<div class="can-refund-number">可退款3456元</div>-->
      <!--<div class="text-color-third">-->
        <!--余额3456元 | 不可退款0元-->
      <!--</div>-->
      <div class="pi-divider margin-top-super margin-bottom-super"></div>
      <div class="my-cash-custom-order">
        <div class="text-size-28 text-color-third">
          我的充值订单
        </div>
        <div class="list-item pi-flex pi-divider pi-center-items" v-for="item in list" :key="item" :title="item" @click="onItemClick">
          <img src="../../assets/img/d72e70cc40071d5964794636618a9d3.png">
          <div class="pi-flex-item padding-left-normal">
            <div class="text-size-32 text-color-second">{{item.rechargeAmount}}</div>
            <div class="text-size-24 text-color-third margin-top-normal">{{item.rechargeTime}}</div>
          </div>
          <div>
            <div class="text-size-32 text-color-first" style="font-weight: 500">¥{{item.availbleRefundAmount}}</div>
            <div class="text-size-24 text-color-third margin-top-normal">可退款</div>
          </div>
          <img style="width: 0.3rem; height: 0.3rem; margin-left: 0.2rem" src="../../assets/img/icon-right.png"
               alt="">
        </div>
        <!--<div class="text-size-28 text-color-third margin-top-super">-->
          <!--不可退款充值订单-->
        <!--</div>-->
        <!--<div class="list-item pi-flex pi-divider pi-center-items" v-for="item in list" :key="item" :title="item">-->
          <!--<img src="../../assets/img/d72e70cc40071d5964794636618a9d3.png">-->
          <!--<div class="pi-flex-item padding-left-normal">-->
            <!--<div class="text-size-32 text-color-second">原路退回到微信钱包</div>-->
            <!--<div class="text-size-24 text-color-third margin-top-normal">2020-03-04  13:33:33</div>-->
          <!--</div>-->
          <!--<div>-->
            <!--<div class="text-size-24 text-color-third margin-top-normal">已退款不可再次退款</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="bottom-content">
        <div class="refund">
          <span class="text-size-28" style="border-bottom: currentColor 1px solid; line-height: 0.4rem">退款记录</span>
          <span>》</span>
        </div>
        <div class="tip text-size-26 padding-normal text-color-third text-center">如有疑问请查看
          <a>退款说明</a>
          或直接
          <a>联系客服</a>
        </div>
      </div>
    </div>
  </pi-content>
</template>

<script>
// import { getCannotRefundRecord, cannotRefundTotal, getUserBalance } from '@/common/api/index';
import { getRefundRechargeList } from '@/common/api/index';

import { List } from 'vant';
import messageBox from '@/components/pi-message/pi-message.js';
export default {
  name: 'my-cash-custom',
  components: {
    [List.name]: List
  },
  data () {
    return {
      list: [
        // {
        //     name : '充值6.70元',
        //     smallName : '2019-06-02  16:46:12',
        //     amount : '6.70元',
        //     amountText : '可退款',
        //     payType : 3
        // },
        // {
        //     name : '充值6.70元',
        //     smallName : '2019-06-02  16:46:12',
        //     amount : '6.70元',
        //     amountText : '可退款',
        //     payType : 3
        // }
      ],
      loading: false,
      finished: false,
      noList: [],
      userMoney: {},
      form: {
        PageIndex: 1,
        PageSize: 10
      },
      currentPage: 0,
      pageSize: 10,
      thisPageCount: null
    };
  },
  methods: {
    onItemClick() {
      this.$router.push('/my/cash/custom/sub');
    },
    async getList () {
      getRefundRechargeList({
        accountPkId: this.$testPkId,
        globalPageIndex: this.currentPage + 1,
        globalPageSize: this.pageSize,
        lastPageAmount: this.thisPageCount
      }).then((data) => {
        if (data.status === 0 && data.data) {
          console.log('fdf');
          if (this.currentPage === 0) {
            this.list = [];
          }
          // test code start
          if (data.data.length === 0) {
            this.list = [{}, {}];
          }
          // end
          this.currentPage++;
          for (let i = 0; i < data.data.length; i++) {
            if (i === 0) {
              this.thisPageCount = data.data[0].thisPageAmout;
            }
            this.list.push(data.data[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.currentPage >= data.totalPage) {
            this.finished = true;
            console.log('fdf8');
          } else {
            this.getList();
          }
        }
      }).catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    goDetails (item, type = '') {
      let data = {
        cashOrder: item.obj,
        userMoney: this.userMoney
      };
      this.$common.save('cashDetails', data);
      this.$router.push('/my/cash/custom/sub?type=' + type);
    },
    tipsShow () {
      let isShow = this.$common.get('cashExplain');
      if (!isShow) {
        this.$common.save('cashExplain', 1);
        messageBox({
          title: '',
          isCancel: false,
          confirmActive: true,
          textActive: true,
          text: '尊敬的用户您好:公众号仅支持可退款金额全额退。不可退余额包含参加活动充值获得赠券的余额。他人代您充值的余额，此部分金额不支持自动退还。申请成功后金额将在0-5个工作日退还至原支付账户。微信原路退还的期限为十二个月。超过退款期限的微信充值会退回到用户余额中。确认要退还他人替您充值的余额，请点击自定义退款，择相应的充值订单进行退还。本规则的解释权归' + this.$config.companyName + '所有。 ?',
          confirm: () => {

          }
        });
      }
    },

    async getNoList () {
      // let ret = await getCannotRefundRecord(this.form);
      // if (ret.status === this.$config.ajaxStatus) {
      //   let list = ret.data.records;
      //   let objList = [];
      //   list.map(item => {
      //     objList.push({
      //       name: '充值' + item.amount + '元',
      //       smallName: this.$common.thisTimes(null, new Date(item.rechargeTimes)),
      //       amount: item.amount,
      //       payType: item.payType,
      //       amountText: '不可退款',
      //       obj: item
      //     });
      //   });
      //   this.noList = objList;
      // }
    },
    // async getList () {
    //   let ret = await canRefundRecord({});
    //   if (ret.status === this.$config.ajaxStatus) {
    //     let list = ret.data.records;
    //     let objList = [];
    //     list.map(item => {
    //       objList.push({
    //         name: '充值' + item.amount + '元',
    //         smallName: this.$common.thisTimes(null, new Date(item.rechargeTimes)),
    //         amount: item.mayRefundFee,
    //         payType: 3,
    //         amountText: '可退款',
    //         obj: item
    //       });
    //     });
    //     this.list = objList;
    //   }
    // },
    async getUser () {
      // let ret = await getUserBalance({});
      // if (ret.status === this.$config.ajaxStatus) {
      //   this.userMoney = ret.data;
      //
      //   let res = await cannotRefundTotal({});
      //   if (res.status === this.$config.ajaxStatus) {
      //     let cannotRefundTotal = res.data.cannotRefundTotal;
      //     this.$set(this.userMoney, 'cannotRefundTotal', cannotRefundTotal);
      //   }
      // }
    }
  },
  mounted () {
    // this.tipsShow();
    // this.getList();
    // this.getNoList();
    //
    // this.getUser();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.my-cash-custom {
  padding: 0.2rem;
 .can-refund-number{
   font-size: 0.32rem;
   font-weight:500;
   color:rgba(102,102,102,1);
   line-height:45px;
 }
  .my-cash-custom-order{

  }
}
.list-item {
  margin: 0 0.2rem;
  padding: 0.2rem 0;
  img {
    width: 0.8rem;
    height: 0.8rem;
  }
}
.bottom-content {
  position: fixed;
  height: 2.1rem;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .refund {
    color: #6FA1F6;
    text-align: right;
  }
  a {
    color: #14C4F5;
    border-bottom: #14C4F5 1px solid;
  }
}
</style>
